import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserGroup } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserGroupService extends BaseApiService<UserGroup> {
  get cacheKey(): StorageKey {
    return StorageKey.userGroupServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/userGroups`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected unparse(obj) {
    return UserGroup.unparse(obj);
  }

  protected parse(obj) {
    return UserGroup.parse(obj);
  }
}
